import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";

import { useLocation } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import OpeningDetails from "../OpeningBalance/OpeningDetails";
import OpeningNew from "../OpeningBalance/OpeningNew";
import OpeningView from "../OpeningBalance/OpeningView";


import RequisitionDetails from "../Requisition/RequisitionDetails";
import RequisitionNew from "../Requisition/RequisitionNew";
import RequisitionView from "../Requisition/RequisitionView";


import DailyIssueDetail from "../DailyIssue/DailyIssueDetail";
import DailyIssueNew from "../DailyIssue/DailyIssueNew";
import DailyIssueView from "../DailyIssue/DailyIssueView";


import Issueheaderdetails from "../IssueReturn/Issueheaderdetails";
import IssueReturnNew from "../IssueReturn/Issuereturnnew";
import Issuedetails from "../IssueReturn/Issuedetail";



import StockAdjustment from "../StockAdjust/RequisitionDetails";
import StockAdjustNew from "../StockAdjust/RequisitionNew";
import StockAdjustView from "../StockAdjust/RequisitionView";




import Chat from "../../Chat/Chat";
import InternalRequsition from "../Register/InternalRequisition";
import IssueReturn from "../Register/IssueReturn";
import PendingInternalRequisition from "../Register/PendingInternalRequisition";
import StockAdjstment from "../Register/StockAdjustment";
import DailyIssue from "../Register/DailyIssue";

const FieldDataS = (fieldProps) => {
  // const location = useLocation();

  // // console.log("Current path:", location.pathname);
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />

       
        <Route
          path="/transaction/opening-balance-create"
          element={<OpeningNew />}
        />
        <Route
          path="/transaction/opening-balance-view/:id"
          element={<OpeningView />}
        />
        <Route
          path="/transaction/opening-balance"
          element={<OpeningDetails />}
        />
        <Route
          path="/transaction/requisition"
          element={<RequisitionDetails />}
        />

        <Route
          path="/transaction/requisition-create"
          element={<RequisitionNew />}
        />
        <Route
          path="/transaction/requisition-view/:id"
          element={<RequisitionView />}
        />





        <Route path="/transaction/dailyIssue" element={<DailyIssueDetail />} />

        <Route
          path="/transaction/dailyIssue-create"
          element={<DailyIssueNew />}
        />
        <Route
          path="/transaction/dailyIssue-view/:id"
          element={<DailyIssueView />}
        />


    <Route path="/transaction/Issuereturn" element={<IssueReturnNew />} />
        {/* <Route path="/transaction/Issuereturn/Issuereturnnew" element={<Issuereturnnew />}/> */}
        <Route
          path="/transaction/Issuereturn/Issueheaderdetails"
          element={<Issueheaderdetails />}
        />

        <Route
          path="/transaction/Issuereturn/details"
          element={<Issuedetails />}
        />

<Route path="/transaction/stock-adj" element={<StockAdjustment />} />

<Route path="/transaction/stock-adj-new" element={<StockAdjustNew />} />
<Route
  path="/transaction/stock-adj-view/:id"
  element={<StockAdjustView />}
/>





      

        <Route path="/transaction/Purchase/Chatbot" element={<Chat />} />
        <Route
          path="/internal-requisition-register"
          element={<InternalRequsition />}
        />
        <Route path="/daily-issue-register" element={<DailyIssue />} />
        <Route path="/issue-return-register" element={<IssueReturn />} />
        <Route path="/stock-adjustment-register" element={<StockAdjstment />} />
        <Route
          path="/pending-internal-requisition"
          element={<PendingInternalRequisition />}
        />
      </Routes>
    </div>
  );
};

export default FieldDataS;
